import * as a from '../services/auth';
import { ActionTypes } from '../types/action-types';

export const updateKey = (accessToken: string, tenantId: string, accountId: string, token: string) => async dispatch => {
    const key = generateKey(accountId, token)
    const auth = await a.updateKey(accessToken, tenantId, key)
    dispatch({
        type: ActionTypes.KEY_UPDATED,
        ...splitKey(auth.key),
    })
};

export const getKey = (accessToken: string, tenantId: string) => async dispatch => {
    const auth = await a.getKey(accessToken, tenantId)
    dispatch({
        type: ActionTypes.KEY_UPDATED,
        ...splitKey(auth.key),
    })
};

export const toggleToken = (show: boolean) => async dispatch => {
    dispatch({
        type: ActionTypes.TOGGLE_TOKEN_VISIBILITY,
        showToken: show,
    })
};

const generateKey = (x: string, y: string) => {
    return `${x}:${y}`
}

const splitKey = (key: string) => {
    const k = key.split(':')
    return {
        accountId: k[0],
        token: k[1],
    }
}





// WEBPACK FOOTER //
// ./src/sub-projects/roostify/actions/auth.ts